import Vue from 'vue';
const TimeLineMax = require("TimelineMax");
const ScrollMagic = require("ScrollMagic");
const EasePack = require("EasePack");
export default Vue.extend({
    name: 'employee-slider',
    props: ['parentImages', 'items'],
    data() {
        return {
            isMobile: false,
            currentImageIndex: 0,
            imageCount: 0,
            currentImage: '',
            intervalLoop: null,
            controller: new ScrollMagic.Controller(),
            starterImages: [],
            randomizedImages: [],
            images: this.parentImages
        };
    },
    beforeMount() {
        this.setIsMobile();
        this.prepareImages();
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.setIsMobile();
        });
        this.intervalLoop = setInterval(() => {
            this.changeImage();
        }, 1500);
        this.shrinkSliderScene();
    },
    methods: {
        setIsMobile() {
            this.isMobile = (window.innerWidth < 640);
        },
        changeImage() {
            if (this.currentImageIndex < this.imageCount - 1) {
                this.currentImageIndex++;
                this.currentImage = this.starterImages[this.currentImageIndex];
            }
            else {
                this.currentImageIndex = 0;
                this.currentImage = this.starterImages[this.currentImageIndex];
            }
        },
        stopInterval() {
            clearInterval(this.intervalLoop);
        },
        shrinkSliderScene() {
            const shrinkScene = new ScrollMagic.Scene({
                triggerElement: '#app',
                triggerHook: 0,
                offset: 1,
                duration: document.getElementById('app').offsetHeight,
            })
                .on('enter', (e) => {
                if (e.scrollDirection === 'FORWARD') {
                    this.stopInterval();
                    this.shrinkSlider().play();
                }
            })
                .setPin('.employee-slider')
                .addTo(this.controller);
        },
        shrinkSlider() {
            let tl = new TimeLineMax();
            tl.to('.employee-slider', 1, {
                transform: "scale(0.5)",
                ease: EasePack.Power2.easeIn
            }).to('.employee-slider', 0.6, {
                opacity: 0
            });
            if (this.isMobile) {
                this.setNewImageBundleOrder();
            }
            // start image scroll when animation almost finished (small overlap)
            this.$emit('shrinkFinished', this.randomizedImages);
            return tl;
        },
        setNewImageBundleOrder() {
            // get source of image where the user startet scrolling
            const startingImageSrc = this.starterImages[this.currentImageIndex].src;
            // get the index of that same image inside the randomizedImages array
            const startingImageIndex = this.randomizedImages.findIndex(image => {
                return image.src === startingImageSrc;
            });
            // remove starter imageBundle from the randomizedImages array
            const imageBundleFromStartingImage = this.randomizedImages.splice(startingImageIndex, startingImageIndex + 6);
            // merge arrays together (so that the starting imageBundle is first in the array)
            this.randomizedImages = imageBundleFromStartingImage.concat(this.randomizedImages);
            // add empty array cause somehow imageScroll verschlucks the first array
            this.randomizedImages.unshift([]);
        },
        prepareImages() {
            /* get CEO image and remove it from this.images */
            let imageCEO = this.images.shift();
            let imageBundles = [];
            /* bundle images and push them to imageBundles */
            for (let i = 1; i < this.items - 1; i += 6) {
                let imagePackage = this.images.slice(i, i + 6);
                imageBundles.push(imagePackage);
            }
            /* shuffle bundledImages */
            Vue.prototype.$shuffleArray(imageBundles);
            // take first image of the first 4 imageBundles
            for (let i = 0; i < 4; i++) {
                if (imageBundles[i][0]) {
                    this.starterImages.unshift(imageBundles[i][0].cloneNode(true));
                }
            }
            this.imageCount = this.starterImages.length;
            /* merge bundles together */
            imageBundles.forEach((bundle) => {
                bundle.forEach((bundleItem) => {
                    this.randomizedImages.push(bundleItem);
                });
            });
            /* add CEO Image back in (only on medium up) */
            if (!this.isMobile) {
                this.randomizedImages.unshift(imageCEO);
                this.randomizedImages.unshift([]); // add placeholder to index 0 in array, cause somehow the imagescroll verschlucks the first image
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/EmployeeSlider/EmployeeSlider.ts
// module id = null
// module chunks = 